import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import routeNames from './routeNames';
import { useXProps } from '../hooks/useXProps';
import EditLocation from '../components/templates/EditLocation/EditLocation';
import PageNotFound from '../components/templates/PageNotFound';
import TOKEN from '../lib/token';
import Home from '../components/templates/Home/Home';

const RootRouter = () => {
  const { initialRoute } = useXProps();

  return (
    <BrowserRouter>
      {initialRoute && !!TOKEN.get() && <Navigate to={initialRoute} />}
      <Routes>
        <Route path={routeNames.root()} element={<Home />} />
        <Route path={routeNames.editLocation()} element={<EditLocation />} />
        <Route path={routeNames.pageNotFound()} element={<PageNotFound />} />
        <Route
          path={routeNames.noPermission()}
          element={<div>No permission page</div>}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default RootRouter;
